import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

class CategoryService {
    static getCategory() {
        let api = '';
        let id = localStorage.getItem("id");
          api = id ? API_PATHS.getCategory + '?_id=' + id : API_PATHS.getCategory;
        
        localStorage.removeItem("id");
        return axios
            .get(api)
            .then((response) => {
                if (response.data) {
                    // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    static uploadCategory(item) {
        return axios
            .post(API_PATHS.uploadCategory,
                item
            )
            .then((response) => {
                if (response.data) {
                    // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    static editCategory(item) {
        let api = '';
        let id = localStorage.getItem("id");
        api = API_PATHS.editCategory + '?id=' + id;
        localStorage.removeItem("id");
        return axios
          .put(api,item)
          .then((response) => {
            if (response.data) {
            
            }
            return response.data;
          });
      }




    static removeUserDetails() {
        localStorage.removeItem("user");
    }

    static getUserDetails() {
        return JSON.parse(localStorage.getItem("user"));
    }
}

export default CategoryService;